/**
 * Learner-portal branding fetch (Phase F2c, re-pointed in SC-4b).
 *
 * The institution's REAL brand — the logo + primary/secondary hex the IA
 * sets in the self-serve editor (`PUT /me/branding`). A tenant who refines
 * their colours during onboarding sees their learners' portal repaint to
 * match: one edit, every surface on-brand (IA shell, apply portal, learner
 * portal).
 *
 * SC-4b re-points this at `GET /tenants/{slug}/public-profile`, which
 * carries the same branding block **and** the tenant's vertical. The portal
 * needs the vertical on the very first paint to mount the right shell, so
 * fetching branding separately would mean two anonymous round-trips for one
 * cold load. `GET /tenants/{slug}/branding` still exists and is still what
 * the SA/IA editors read after a save.
 *
 * The read is anonymous so it lands on the cold login screen before a
 * learner signs in, and shares the profile query's cache entry — so the
 * shell and the brand can never disagree about which tenant they belong to.
 */

import { useTenantProfile } from "@/lib/tenantProfile/api";
import type { BrandingPublic } from "./types";

export function useTenantBranding(slug: string | null | undefined): {
  data: BrandingPublic | undefined;
  isLoading: boolean;
} {
  const { data, isLoading } = useTenantProfile(slug);
  return { data: data?.branding, isLoading };
}
